// src/components/AutoSaveIndicator.tsx
import React from 'react';
import { Check, Cloud, CloudOff, Loader2 } from 'lucide-react';
import { formatLastSaved } from '@/hooks/useAutoSave';

interface AutoSaveIndicatorProps {
  isSaving: boolean;
  lastSaved: Date | null;
  error: string | null;
  className?: string;
}

export function AutoSaveIndicator({ isSaving, lastSaved, error, className = '' }: AutoSaveIndicatorProps) {
  if (error) {
    return (
      <div className={`flex items-center gap-2 text-red-400 text-sm ${className}`}>
        <CloudOff className="w-4 h-4" />
        <span>Save failed: {error}</span>
      </div>
    );
  }

  if (isSaving) {
    return (
      <div className={`flex items-center gap-2 text-blue-400 text-sm ${className}`}>
        <Loader2 className="w-4 h-4 animate-spin" />
        <span>Saving...</span>
      </div>
    );
  }

  if (lastSaved) {
    return (
      <div className={`flex items-center gap-2 text-green-400 text-sm ${className}`}>
        <Check className="w-4 h-4" />
        <span>Saved {formatLastSaved(lastSaved)}</span>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 text-slate-400 text-sm ${className}`}>
      <Cloud className="w-4 h-4" />
      <span>Auto-save enabled</span>
    </div>
  );
}
